import { render, staticRenderFns } from "./MainWallet.vue?vue&type=template&id=07a5ce64&scoped=true"
import script from "./MainWallet.vue?vue&type=script&lang=js"
export * from "./MainWallet.vue?vue&type=script&lang=js"
import style0 from "./MainWallet.vue?vue&type=style&index=0&id=07a5ce64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a5ce64",
  null
  
)

export default component.exports